// To do: Fix responsiveness of table and form
import {
  Heading,
  Container,
  VStack,
  Text,
  Code,
  Button,
  Box,
  FormControl,
  HStack,
  FormLabel,
  Input,
  useToast,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Card,
  Center,
} from "@chakra-ui/react";
import Layout from "../../../layout/Layout";
import { Element } from "react-scroll";
import { useState } from "react";
import { CopyIcon } from "@chakra-ui/icons";
import AddressMapComponent from "../../../components/mapcomponent/address";
import ContentMenu from "../../../components/content-menu";

type AddressInfo = {
  "Building Name": string;
  City: string;
  "Floor/Building Number": string;
  Landmark: string;
  Locality: string;
  State: string;
  "Street Address": string;
  ZipCode: number;
  score: number;
  status: string;
};

export default function AddressParsing() {
  console.log("Address parsing loaded");
  const [apiKey, setApiKey] = useState("");
  const [address, setAddress] = useState("");
  const [locationAddress, setLocationAddress] = useState("");
  const [apiResponse, setApiResponse] = useState("");
  const [geocodes, setGeocodes] = useState([0, 0]);
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();
  const navItems = [
    { title: "Address Parsing", nav: "addressparsing" },
    { title: "Try out the API", nav: "playground" },
    { title: "API request body parameters", nav: "requestbodyparameters" },
    { title: "Sample API request", nav: "sample" },
  ];

  const buildLocationAddress = (data: AddressInfo): string => {
    const locationParts: string[] = [];
    for (const [key, value] of Object.entries(data)) {
      if (value !== "" && value !== "NA" && key != "score" && key != "status") {
        locationParts.push(`${value}`);
      }
    }
    return locationParts.join(", ");
  };

  const handleCopy = () => {
    apiResponse && navigator.clipboard.writeText(apiResponse);
    toast({
      title: "Success!",
      description: "API response successfully copied to your clipboard",
      status: "success",
      duration: 5000,
      isClosable: true,
    });
  };

  async function handleSubmit() {
    try {
      setIsLoading(true);

      const response = await fetch(`${process.env.REACT_APP_ADDRESS_PARSING}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": apiKey,
        },
        body: JSON.stringify({ address }),
      });

      var data = await response.json();

      var newAddress = buildLocationAddress(data);
      setLocationAddress(newAddress);

      if (data.score) {
        const geocodeResponse = await fetch(
          `${process.env.REACT_APP_V2_API_SERVER_ENDPOINT}/geocode/search?address=${newAddress}`,
          {
            method: "GET",
            headers: {
              "X-Api-Key": `${process.env.REACT_APP_GEOCODE_SEARCH_V2_API_KEY}`,
            },
          }
        );
        var geocodeData = await geocodeResponse.json();

        setGeocodes([
          geocodeData.results[0].geometry.location.lng,
          geocodeData.results[0].geometry.location.lat,
        ]);

        toast({
          title: "Success!",
          description: "Address Parsing successfully completed",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      } else if (data.Error) {
        if (apiKey == "" || apiKey == " " || apiKey == null) {
          toast({
            title: "Error!",
            description: "Please enter an API key",
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        } else {
          toast({
            title: "Error!",
            description: "Please check your input",
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        }
      }

      setApiResponse(JSON.stringify(data, null, 2));
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      toast({
        title: "Error!",
        description: "There was an error fetching data",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  }

  return (
    <Layout
      children={
        <Container maxW={"7xl"} px={{ base: 4, md: 8, lg: 12 }} py={12}>
          <ContentMenu items={navItems} />
          <VStack spacing="10" alignItems="flex-start" w="full">
            <Element name="addressparsing" style={{ width: "100%" }}>
              <Heading as="h2">Address Parsing</Heading>
              <Text as="p" fontSize={"lg"} mt={5} textDecoration={"underline"}>
                v1/address/parse-address
              </Text>
              <Text as="p" fontSize="lg" mt={5}>
                The Address Parsing API is a powerful tool designed to simplify
                the process of extracting various components from a given
                address string. You can seamlessly break down an address into
                distinct elements, including house number, floor or flat number,
                building name, street name, landmark, city, state, pin code, and
                country.
              </Text>
            </Element>
            <Element name="playground" style={{ width: "100%" }}>
              <Box w="full">
                <Heading as="h2">Try out the API</Heading>
                <FormControl isRequired mt={"20px"} w={"100%"}>
                  <HStack
                    spacing={{ base: 6, lg: 20 }}
                    w="full"
                    flexWrap="wrap"
                    alignContent={"space-between"}
                  >
                    <HStack>
                      <FormLabel whiteSpace={"nowrap"} pb={0} mb={0}>
                        API Key
                      </FormLabel>
                      <Input
                        type="text"
                        w="100%"
                        placeholder="Enter API key"
                        borderColor={"#bcbcbc"}
                        value={apiKey}
                        onChange={(e) => setApiKey(e.target.value)}
                      />
                    </HStack>
                    <HStack>
                      <FormLabel whiteSpace={"nowrap"} pb={0} mb={0}>
                        Address
                      </FormLabel>
                      <Input
                        type="text"
                        placeholder="Enter address"
                        borderColor={"#bcbcbc"}
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                      />
                    </HStack>
                    <Button
                      isLoading={isLoading}
                      loadingText="Loading"
                      bg="black"
                      color="white"
                      _hover={{
                        bg: "white",
                        color: "black",
                        border: "solid 1px black",
                      }}
                      onClick={handleSubmit}
                      isDisabled={!address}
                      variant={"outline"}
                      my={"10px"}
                    >
                      Execute
                    </Button>
                  </HStack>
                </FormControl>
                <Tabs mt="40px" align="center">
                  <TabList>
                    <Tab>Map</Tab>
                    <Tab>Details</Tab>
                  </TabList>

                  <TabPanels>
                    <TabPanel>
                      {geocodes[0] !== 0 && geocodes[1] !== 0 ? (
                        <AddressMapComponent
                          geocodes={geocodes}
                          address={locationAddress}
                        />
                      ) : (
                        <Center>
                          <Text>
                            Send an API request to view the location on the map
                          </Text>
                        </Center>
                      )}
                    </TabPanel>
                    <TabPanel>
                      <Box>
                        <Box position="relative">
                          <Code
                            bg={"black"}
                            color={"white"}
                            whiteSpace="pre"
                            p="12"
                            width={"100%"}
                            textAlign={"left"}
                          >
                            {apiResponse
                              ? apiResponse
                              : "Send an API request to see a response here"}
                          </Code>
                          <Button
                            color={"white"}
                            _hover={{
                              bg: "white",
                              color: "black",
                              borderColor: "black",
                            }}
                            size="sm"
                            position="absolute"
                            top="0"
                            right="0"
                            mt={"15px"}
                            mr={"10px"}
                            onClick={handleCopy}
                            variant={"outline"}
                            leftIcon={<CopyIcon />}
                          >
                            Copy
                          </Button>
                        </Box>
                      </Box>
                    </TabPanel>
                  </TabPanels>
                </Tabs>
              </Box>
            </Element>
            <Element name="requestbodyparameters" style={{ width: "100%" }}>
              <Heading as="h2">API request body parameters</Heading>
              <Text as="p" fontSize="lg" mt={5}>
                The Address Parsing API is capable of taking in address string
                inputs that don't contain spaces or commas.
              </Text>
              {/* Note: Make the table responsive, refer to api key table in dashboard */}
              <TableContainer boxShadow={"lg"} mt={8}>
                <Table>
                  <Thead>
                    <Tr>
                      <Th>Parameter</Th>
                      <Th>Type</Th>
                      <Th>Required</Th>
                      <Th>Default</Th>
                      <Th>Example</Th>
                    </Tr>
                  </Thead>
                  <Tbody bg="#edf2f7">
                    <Tr>
                      <Td>address</Td>
                      <Td>string</Td>
                      <Td>yes</Td>
                      <Td>none</Td>
                      <Td>
                        123, 4B Rose Apartments Main Street, Central Park
                        Metropolis, Bangalore Karnataka 560001 India
                      </Td>
                    </Tr>
                  </Tbody>
                </Table>
              </TableContainer>
            </Element>
            <Element name="sample" style={{ width: "100%" }}>
              <Heading as="h2">Sample API request</Heading>
              <Text as="p" fontSize="lg" mt={5}>
                <VStack align={"flex-start"} spacing={8}>
                  <HStack>
                    <Text as="b" textDecoration={"none"}>
                      URL:
                    </Text>
                    <Text textDecoration={"underline"} wordBreak="break-all">
                      api.potterstech.com/v1/address/parse-address
                    </Text>{" "}
                  </HStack>
                  <Text as="b">API Request Body:</Text>
                  <Card
                    borderRadius={30}
                    bg="#edf2f7"
                    p="8"
                    boxShadow={"lg"}
                    w="100%"
                    fontSize={"sm"}
                  >
                    <Text as="samp">
                      &#123; <br /> "address":"123, 4B Rose Apartments Main
                      Street, Central Park Metropolis, Bangalore Karnataka
                      560001 India" <br />
                      &#125;
                    </Text>
                  </Card>
                  <Text as="b">API Response:</Text>
                  <Card
                    borderRadius={30}
                    bg="#edf2f7"
                    p="8"
                    boxShadow={"lg"}
                    w="100%"
                    fontSize={"sm"}
                  >
                    <Text as="samp">
                      &#123; <br />
                      "Floor/Building Number": "123, 4B",
                      <br /> "Building Name": "Rose Apartments",
                      <br /> "Street Address": "Main Street",
                      <br /> "Landmark": "Central Park",
                      <br /> "Locality": "Metropolis",
                      <br /> "City": "Bangalore",
                      <br /> "State": "Karnataka",
                      <br /> "ZipCode": 560001,
                      <br /> "score": 100,
                      <br /> "status": "complete"
                      <br /> &#125;
                    </Text>
                  </Card>
                </VStack>
              </Text>
              </Element>
          </VStack>
        </Container>
      }
    />
  );
}
